// extracted by mini-css-extract-plugin
export default {"title":"issue-event-logs_title__R0KcZ"};